import React, { useState } from 'react';
import { motion, useScroll } from 'framer-motion';
import { MenuIcon, XIcon, WorkflowIcon } from 'lucide-react';
import { navItems } from '../data/articleLists';
import { site } from '../data/site';
export function SiteHeader() {
  const [open, setOpen] = useState(false);
  const {
    scrollYProgress
  } = useScroll();
  return <header className="glass sticky top-0 z-50 border-x-0 border-t-0" data-id="element-218" data-mp="1iolf0c2ua8oh">
      <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-5 md:px-8" data-id="element-219" data-mp="uzaacjidbu52">
        <a href="#top" className="flex items-center gap-2.5 text-ink" aria-label={`${site.name} home`} data-id="element-220" data-mp="qxp4hi494g4d">
          <span className="grid h-8 w-8 place-items-center rounded-lg bg-aurora-blue/20 text-aurora-cyan ring-1 ring-aurora-cyan/30" data-id="element-221" data-mp="14xgez8vk7edm">
            <WorkflowIcon className="h-4 w-4" aria-hidden="true" data-id="element-222" data-mp="zzevwny4vf25" />
          </span>
          <span className="font-display text-lg font-semibold tracking-tight" data-id="element-223" data-mp="2ga0qcht0qfdq">{site.name}</span>
        </a>

        <nav aria-label="Primary" className="hidden md:block" data-id="element-224" data-mp="2bc8trahfi537">
          <ul className="flex items-center gap-1" data-id="element-225" data-mp="29isc1qi9udnt">
            {navItems.map(item => <li key={item.href} data-id="element-226" data-mp="2ei3ud3yadr7i">
                <a href={item.href} className="rounded-lg px-3 py-2 text-sm text-muted transition-colors duration-150 hover:bg-white/5 hover:text-ink" data-id="element-227" data-mp="2eh2803btliah">
                  {item.label}
                </a>
              </li>)}
          </ul>
        </nav>

        <div className="flex items-center gap-2" data-id="element-228" data-mp="1qrhmpds728y1">
          <a href={site.tkxelServiceUrl} target="_blank" rel="noopener" className="hidden whitespace-nowrap rounded-lg bg-aurora-cyan px-4 py-2 text-sm font-semibold text-night transition-colors duration-150 hover:bg-cyan-300 sm:inline-flex" data-id="element-229" data-mp="1vtgseubephy5">
            Talk to tkxel
          </a>
          <button type="button" className="grid h-10 w-10 place-items-center rounded-lg text-ink hover:bg-white/5 md:hidden" aria-expanded={open} aria-controls="mobile-nav" aria-label={open ? 'Close menu' : 'Open menu'} onClick={() => setOpen(v => !v)} data-id="element-230" data-mp="180qggl3i6ynv">
            {open ? <XIcon className="h-5 w-5" data-id="element-231" data-mp="1eraz0gc0etzm" /> : <MenuIcon className="h-5 w-5" data-id="element-232" data-mp="1eqi1m5yxxgu5" />}
          </button>
        </div>
      </div>

      {open && <nav id="mobile-nav" aria-label="Mobile" className="border-t border-line px-5 pb-4 md:hidden" data-id="element-233" data-mp="19sq6z46wvgm9">
          <ul className="flex flex-col pt-2" data-id="element-234" data-mp="m2m2kulwfcu7">
            {navItems.map(item => <li key={item.href} data-id="element-235" data-mp="h4u39fixcofz">
                <a href={item.href} onClick={() => setOpen(false)} className="block rounded-lg px-3 py-3 text-base text-muted hover:bg-white/5 hover:text-ink" data-id="element-236" data-mp="w0jtxqz21pr1">
                  {item.label}
                </a>
              </li>)}
            <li className="mt-2" data-id="element-237" data-mp="22gvqjnm8azki">
              <a href={site.tkxelServiceUrl} target="_blank" rel="noopener" className="block rounded-lg bg-aurora-cyan px-3 py-3 text-center font-semibold text-night" data-id="element-238" data-mp="22fu6wur5d4r6">
                Talk to tkxel
              </a>
            </li>
          </ul>
        </nav>}

      <motion.div aria-hidden="true" className="absolute inset-x-0 bottom-0 h-0.5 origin-left bg-aurora-cyan" style={{
      scaleX: scrollYProgress
    }} data-id="element-239" data-mp="2511y05a1x85t" />
    </header>;
}